
/**
 * Returns a number whose value is limited to the given range.
 *
 * Example: limit the output of this computation to between 0 and 255
 * `clamp(0, 2*x + 6, 255)`
 *
 * @param {Number} min The lower boundary of the output range
 * @param {Number} value The value to be clamped
 * @param {Number} max The upper boundary of the output range
 * @returns A number in the range [min, max]
 * @type Number
 */
export function clamp(min: number, value: number, max: number) {
  return Math.min(Math.max(value, min), max);
}

export function truncateStart(str: string, n: number) {
  return str.length > n ? `${str.substring(0, n)}...` : str;
}

export function truncateEnd(str: string, n: number) {
  return str.length > n ? `...${str.substring(str.length - n)}` : str;
}
